export var SimpleTooltipPosition;
(function (SimpleTooltipPosition) {
    SimpleTooltipPosition["UP"] = "UP";
    SimpleTooltipPosition["DOWN"] = "DOWN";
    SimpleTooltipPosition["LEFT"] = "LEFT";
    SimpleTooltipPosition["RIGHT"] = "RIGHT";
    SimpleTooltipPosition["INSIDE"] = "INSIDE";
})(SimpleTooltipPosition || (SimpleTooltipPosition = {}));
//# sourceMappingURL=simple-tooltip.types.js.map